const ERROR_REASONS = {
  GOOGLE_LOGIN_FAILED_SDK: 'GOOGLE_LOGIN_FAILED_SDK | Source: FE',
  FETCH_CSRF_TOKEN: 'FETCH_CSRF_TOKEN | Source: FE',
  FETCH_CSRF_TOKEN_NOT_OK: 'FETCH_CSRF_TOKEN_NOT_OK | Source: FE',
  FETCH_CSRF_TOKEN_NO_EXIST: 'FETCH_CSRF_TOKEN_NO_EXIST | Source: FE',
  VALIDATE_GOOGLE_CSRF_TOKEN_FAILED_CATCH:
    'VALIDATE_GOOGLE_CSRF_TOKEN_FAILED_CATCH | Source: FE',
  VALIDATE_GOOGLE_CSRF_TOKEN_TRY: 'VALIDATE_GOOGLE_CSRF_TOKEN_TRY | Source: FE',
};

const ERROR_CODES = {
  [ERROR_REASONS.GOOGLE_LOGIN_FAILED_SDK]: 1,
  [ERROR_REASONS.FETCH_CSRF_TOKEN]: 2,
  [ERROR_REASONS.FETCH_CSRF_TOKEN_NOT_OK]: 3,
  [ERROR_REASONS.FETCH_CSRF_TOKEN_NO_EXIST]: 4,
  [ERROR_REASONS.VALIDATE_GOOGLE_CSRF_TOKEN_FAILED_CATCH]: 5,
  [ERROR_REASONS.VALIDATE_GOOGLE_CSRF_TOKEN_TRY]: 6,
};

export { ERROR_CODES, ERROR_REASONS };
